/**
 * Project identity colours for the merged (portfolio) views: the validated
 * categorical palette, assigned in fixed slot order by portfolio position and
 * used only when a project has no colour of its own. Beyond eight projects the
 * hues repeat; the code label next to every swatch keeps identity unambiguous.
 */
const LIGHT = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'] as const
const DARK = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'] as const

export const PROJECT_COLORS: readonly string[] = LIGHT
export const PROJECT_COLORS_DARK: readonly string[] = DARK

const dark = () => typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches

/** The palette colour for the i-th project of a portfolio (0-based). */
export function projectColor(i: number): string {
  const p = dark() ? DARK : LIGHT
  return p[((i % p.length) + p.length) % p.length]!
}
